export const AUDIO_LEVEL_THRESHOLD = 200;
export const AUDIO_LEVEL_STANDARD_DEVIATION_THRESHOLD = AUDIO_LEVEL_THRESHOLD * 0.05;
export const RECORD_DURATION = 4e3;
